import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDescription,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
  cilCircle,
  cilDoor,
  cilList,
  cilHome,
  cilNewspaper,
  cilBolt,
  cilFeaturedPlaylist,
  cilDollar,
  cilPeople,
  cilChatBubble,
  cilHighligt,
  cilStorage,
  cilPhone,
  cilPen,
  cilInfo,
  cilMic,
  cilDiamond,
  cilCalendarCheck,
  cilCalendar,
  cilRectangle,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle, CNavLink } from '@coreui/react-pro'

/*
   사전감정     - MenuUser_01
   방문예약     - MenuUser_02

   내계약       - MenuUser_04 - OrderListMyUser_pwan - 감정완료 이후건 포함
   감정내역     - MenuUser_03 - OrderListUser_pwan - 전체리스트가 포함
   방문예약내역 - MenuUser_05 - space/SpaceUseListUser_pwan
*/

// 메뉴설정
// 1. _navCus.js 에서 items 하위 to, name 설정
// 2. route.js 에서 path, name 설정 (1번의 to, name 과 동일)
// 3. route.js 에서 element 설정
const _nav = [
  {
    component: CNavTitle,
    name: '전당포사나이',
    className: 'small py-2',
  },
  {
    component: CNavItem,
    name: '대출신청',
    // to: '/pwan/orderGoodsPwanDetailsList?mode=input',
    to: '/commonMenu/MenuUser_01', // GoodsListUser
    icon: <CIcon icon={cilDiamond} customClassName="nav-icon" />,
    className: 'small py-1',
  },
  {
    component: CNavItem,
    name: '금팔기',
    to: '/commonMenu/MenuUser_06', // GoodsListUser
    icon: <CIcon icon={cilRectangle} customClassName="nav-icon" />,
    className: 'small py-1',
  },
  // {
  //   component: CNavItem,
  //   name: '금사기 방문예약',
  //   // to: '/order/orderList',
  //   to: '/commonMenu/MenuUser_02', // GoodsListUser
  //   icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
  //   className: 'small py-1',
  // },
  {
    component: CNavTitle,
    name: '마이페이지',
    className: 'small py-2',
  },
  // {
  //   component: CNavItem,
  //   name: '담보물품정보 (삭제예정)',
  //   to: '/commonMenu/MenuUser_04', // OrderInputUser (사용안함?) > OrderListUser
  //   icon: <CIcon icon={cilFeaturedPlaylist} customClassName="nav-icon" />,
  //   className: 'small py-1',
  // },
  {
    component: CNavItem,
    name: '방문예약내역',
    // to: '/space/spaceUseList',
    to: '/commonMenu/MenuUser_05', // OrderListUser
    icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    className: 'small py-1',
  },
  {
    component: CNavItem,
    name: '나의 대출내역',
    // to: '/pwan/orderGoodsPwanDetailsList',
    to: '/commonMenu/MenuUser_03', // OrderListUser
    icon: <CIcon icon={cilPen} customClassName="nav-icon" />,
    className: 'small py-1',
  },
  {
    component: CNavItem,
    name: '나의 판매내역',
    // to: '/pwan/orderGoodsPwanDetailsList',
    to: '/commonMenu/MenuUser_07', // OrderListUser
    icon: <CIcon icon={cilFeaturedPlaylist} customClassName="nav-icon" />,
    className: 'small py-1',
  },
  // {
  //   component: CNavItem,
  //   name: '이자상환내역',
  //   to: '/pwan/orderGoodsPwanDetailsBackList',
  //   icon: <CIcon icon={cilDollar} customClassName="nav-icon" />,
  //   className: 'small',
  // },
  // {
  //   component: CNavTitle,
  //   name: '고객센터',
  //   className: 'small py-2',
  // },
  // {
  //   component: CNavItem,
  //   name: '이용가이드',
  //   to: '/commonMenu/MenuGuideUser', // Guide
  //   icon: <CIcon icon={cilInfo} customClassName="nav-icon" />,
  //   className: 'small py-1',
  // },
  // {
  //   component: CNavItem,
  //   name: '공지사항',
  //   // to: '/center/noticeList',
  //   to: '/commonMenu/MenuNoticeListUser', // Notice
  //   icon: <CIcon icon={cilMic} customClassName="nav-icon" />,
  //   className: 'small py-1',
  // },
]

export default _nav
